export interface FileTypesRecord {
    classification: string,
    fileTypeId: string,
    isAutoSyncEnabled: boolean,
    extension: string,
    fileTypeName: string,
    isHashingEnabled: boolean,
    isCloudOriginated: boolean,
    isDefaultConfig: boolean,
    isRegistrationRelated: boolean,
    mastership: string,
    isOnDemandSupported: boolean,
    isPushEnabled: boolean,
    isShaSyncSupported: boolean,
    isSwapsEnabled: boolean,
    isTransferOverrideEnabled: boolean,
    defaultConfigValue: string,
    commandQueueLimit: string,
    fileTypeFamily: string,
    transferDirection: string
    isRadioDropEnabled?:boolean
  }

  export interface AdminState {
    manageFileTypes: FileTypesRecord;
    autocompleteList: Array<string>;
    mastershipList: Array<string>
    transferDirectionList: Array<string>
    classificationList: Array<string>
    commandQueueLimitList: Array<string>

  }

  export enum AdminActionNames {
    SET_MANAGE_FILE_TYPES = 'SET_MANAGE_FILE_TYPES',
    SET_FILE_TYPE_AUTOCOMPLETE = 'SET_FILE_TYPE_AUTOCOMPLETE',
    SET_ADD_NEW_FILE_TYPE_ID = 'SET_ADD_NEW_FILE_TYPE_ID'
  }

  interface SetManageFileTypes {
    type: typeof AdminActionNames.SET_MANAGE_FILE_TYPES;
    payload: FileTypesRecord;
  }
  interface SetFileTypesAutoComplete {
    type: typeof AdminActionNames.SET_FILE_TYPE_AUTOCOMPLETE
    payload: FileTypesRecord[];
  }

  interface SetAddNewFileTypeId {
    type: typeof AdminActionNames.SET_ADD_NEW_FILE_TYPE_ID,
    payload: string

  }

  export type AdminActionTypes =
    | SetManageFileTypes
    | SetFileTypesAutoComplete
    | SetAddNewFileTypeId